import React from 'react';
import { string, oneOf, bool } from 'prop-types';
import classnames from 'classnames';

import iconStyles from 'styles/icons.css';

const sizeMap = {
  '15': '15px',
  '20': '20px',
  '30': '30px',
  '40': '40px',
  '80': '80px',
  'navigation': '25px',
  'social': '25px'
};

const Icon = props => {
  const { icon, type, customClasses, responsive } = props;

  const iconClass = type ? `icon-${icon}-${type}` : `icon-${icon}`;
  const classes = classnames(
    iconStyles.icon,
    iconStyles[iconClass], customClasses
  );

  let iconSize = {};

  if (type == 'other') {
    const index = icon.lastIndexOf('-');
    const size = icon.substr(index + 1);

    iconSize = { fontSize: `${size}px` };
  } else {
    iconSize = { fontSize: sizeMap[type] };
  }

  if(responsive) {
    iconSize = {};
  }

  return <i style={iconSize} className={classes} />;
};

Icon.propTypes = {
  customClasses: string,
  icon: string.isRequired,
  type: oneOf([
    '15',
    '20',
    '30',
    '40',
    '80',
    'navigation',
    'other',
    'social'
  ]),
  responsive: bool,
};

Icon.defaultProps = { customClasses: '' };
Icon.displayName = 'Icon';

export default Icon;



// WEBPACK FOOTER //
// ./src/uis/foundations/Icons/Icon.js